import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { PasswordValid } from "../constants/Validation";
import { Texterror } from "../constants/Texterror";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { passwordForget } from "../redux/actions/authActions";
import { imageUrls } from "../constants/images";
import "../../styles/auth.scss";
import "../../styles/forgotpass.scss";
export const ForgotPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.forgotPaswword);
  const handleforgot = (values) => {
    dispatch(passwordForget(values, history));
  };
  return (
    <div>
      <div className="login_ss forgot_layout">
        <Container className="p-3">
          <Row className="d-flex justify-content-center align-items-center h-100">
            <Col>
              <div className="open_form">
                <div className="main_box">
                  <div className="p-5 card-body w-100 d-flex flex-column">
                    <img
                      src={imageUrls.logo}
                      className="img-fluid"
                      alt="Phone"
                    />
                    <div className="mini_kog">
                      <h2 className="fw-bold mb-2 text-center">
                        Forgot Password?
                      </h2>

                      <p className="mb-4 text-center">
                        Please enter your email address to send a reset password
                        link
                      </p>

                      <Formik
                        initialValues={{
                          user_email: "",
                        }}
                        validationSchema={PasswordValid}
                        onSubmit={(values, { resetForm }) => {
                          handleforgot(values);
                          resetForm();
                        }}
                      >
                        {({ values, touched, errors, handleSubmit }) => (
                          <Form onSubmit={handleSubmit}>
                            <div className="mb-3">
                              <Field
                                className={`form-control ${
                                  touched.email && errors.email
                                    ? "is-invalid"
                                    : ""
                                }`}
                                name="user_email"
                                placeholder="Email"
                                type="email"
                                value={values.user_email}
                              />
                              <ErrorMessage
                                name="user_email"
                                component={Texterror}
                              />
                            </div>

                            <button type="submit" className="sign_btn mb-4">
                              {isLoading ? (
                                <>
                                  <Spinner />
                                </>
                              ) : (
                                "Send"
                              )}
                            </button>
                          </Form>
                        )}
                      </Formik>

                      <div className="newlane mb-4"></div>
                      <p className="text-center">
                        Already have an account? {""}
                        <Link to={`/`} className="forgot">
                          Sign In Here
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};
